import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as dg from '@mitranim/js/dom_global'
import * as u from './util.mjs'
import {A, E} from './util.mjs'
import * as d from './dat.mjs'
import * as ei from './elem-input.mjs'
import * as eff from './elem-form-field.mjs'

export class FormFieldSelectSingle extends eff.FormField {
  static {dr.reg(this)}
  get Input() {return FormFieldInputSelectSingle}
  get A() {return super.A.cls(`form-custom-select`)}

  initFromSpec(src) {
    src = a.toInst(src, d.UiField)

    return E(super.init(), {},
      new this.Label(this).initFromSpec(src),
      new this.Input(this).initFromSpec(src),
    )
  }
}

/*
Technical note. Native `<select>` supports both single-select and multi-select
mode. This class supports only single-select for simplicity. For multi-select,
we prefer to use groups of checkboxes, which provides a better UX. See
`FormFieldSelectMulti`.
*/
class FormFieldInputSelectSingle extends ei.MixFormElem(u.MixElem(dg.global.HTMLSelectElement)) {
  static {dr.reg(this)}
  get Option() {return FormFieldOption}

  initFromSpec(spec) {
    spec = a.toInst(spec, d.UiField)

    const drawOption = sel => new this.Option(this).initFrom(sel, spec)

    return E(
      this,
      A.name(spec.name),
      a.map(spec.selectables, drawOption),
    )
  }

  /*
  Invoked by `Form` when building form body for JSON.
  Assumes `.multiple = false`.
  */
  addFormValue(tar) {
    a.reqDict(tar)

    const name = this.name
    if (!a.optStr(name)) return

    const opt = a.head(this.selectedOptions)
    if (opt) tar[name] = opt.getValue() ?? null
  }
}

class FormFieldOption extends ei.MixElemValued(ei.MixFormElem(u.MixElem(dg.global.HTMLOptionElement))) {
  static {dr.reg(this)}

  initFrom(sel, spec) {
    a.reqInst(sel, d.UiSelectable)
    spec = a.toInst(spec, d.UiField)
    this.setValue(sel.value)

    /*
    TODO: instead of comparing values, encode the spec value exactly the same
    way as we encode option values, and compare the resulting strings. This
    would be simpler (no need to deep-walk structured data), and consistent
    with how the DOM compares value strings on any change events.
    */
    this.setSelected(u.equiv(sel.value, spec.getValueSingle()))

    return E(this, {}, u.selTitle(sel))
  }

  getSelected() {return this.selected}
  setSelected(val) {return this.selected = a.laxBool(val), this}
}
